import React, {Component,PropTypes} from 'react'





class Slider extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value,
    };
    this.handleChange=this.handleChange.bind(this);
   
  }

  handleChange(event) {

    this.setState({value: event.target.value});
    console.log(event.target.value);
    this.props.updateAction(this.props.theKey,event.target.value);
  }

 






  render() {

          
         
             
        return (


            <div className="form-group label-floating is-empty">
             
                 <div className="slidecontainer">
                          <label text-align="center"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Valor : {this.state.value} </label>
                          
                          <input type="range" min="1" max="100" step="1" className="slidercode" value={this.state.value} onChange={this.handleChange}   />
                
             </div>
             </div>
     
      )


  } 
}
export default Slider;

Slider.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/fields/Slider.js